export default __webpack_public_path__ + "static/media/tenants_main_3_ro.ac91616f.webp";